import { expressEventListener, expressQuerySelectorAll } from "../../common/html";
import { compositeDisposable } from "../../utils/disposable";

export interface INavigationDesktopDeps {
	activatedElement: (selectedElement: HTMLElement) => void;
	getActiveIndex: () => number;
}
export function CreateNavigationDesktopFirstLevel(container: HTMLElement, deps: INavigationDesktopDeps) {
	const navigationItems = expressQuerySelectorAll<HTMLElement>(container, ".technical-navigation-item");
	const { activatedElement } = deps;

	const disposibles = navigationItems.map((x) => {
		return compositeDisposable([
			expressEventListener(x, "click", () => {
				activatedElement(x);
			}),
			expressEventListener(x, "mouseover", () => {
				activatedElement(x);
			}),
		]);
	});

	return {
		dispose: () => disposibles.forEach((x) => x.dispose()),
	};
}
